import IconRoundel from "@/components/IconRoundel";
import clsx from "clsx";
import dayjs from "dayjs";
import React from "react";
import { Calendar } from "react-feather";

const EventDate = ({ event, iconTheme = "light" }) => {
  const eventStart = dayjs(event.startDateTime);
  const eventStartFormatted = eventStart.format("dddd D MMMM");

  return (
    <div className={clsx("flex items-center space-x-3")}>
      <IconRoundel icon={Calendar} theme={iconTheme} />
      <div className={clsx("")}>{eventStartFormatted}</div>
    </div>
  );
};

export default EventDate;
